import { RouteConfig } from "vue-router";

export const REmployerEmployeesTemplateEmployment: RouteConfig = {
  path: "employment",
  component: () =>
    import(
      /* webpackChunkName: "employer-employees-template-employment" */
      "./VEmployerEmployeesTemplateEmployment.vue"
    ),
  meta: {
    title: "Employees",
    label: "employment",
    tabName: "employee_employment",
    alias: "employment",
  },
};
